import { cn } from "@/lib/utils";

interface GroupBadgeProps {
	name: string;
	selected?: boolean;
	onClick?: () => void;
	className?: string;
}

export const GroupBadge: React.FC<GroupBadgeProps> = ({ name, onClick, className, selected }) => {
	return (
		<div
			onClick={onClick}
			className={cn("cursor-pointer rounded bg-muted px-1 text-[10px]", selected && "bg-gray-300", className)}
		>
			{name}
		</div>
	);
};
